import type { DevelopmentSiteTemplate } from '../dev-site-schema.js';

export type SelectionSource = 'env' | 'config';

export interface SiteOutput {
  siteId: string;
  displayName: string;
  viewUrl?: string;
}

export type DevSiteOutput =
  | { event: 'sites'; sites: SiteOutput[] }
  | { event: 'current'; siteId: string; source: SelectionSource }
  | {
      event: 'created';
      siteId: string;
      displayName: string;
      template: DevelopmentSiteTemplate;
    }
  | {
      event: 'installation_required';
      siteId: string;
      installUrl: string;
    }
  | { event: 'selected'; siteId: string; source: SelectionSource };

export function formatHumanDevSiteOutput(output: DevSiteOutput) {
  switch (output.event) {
    case 'sites':
      return output.sites.length === 0
        ? 'No sites found.'
        : output.sites
            .map(
              (site) =>
                `"${site.siteId}"\t${site.displayName}${
                  site.viewUrl ? `\t${site.viewUrl}` : ''
                }`
            )
            .join('\n');
    case 'current':
      return `Current development site "${output.siteId}": ${output.source}`;
    case 'created':
      return `Created development site "${output.siteId}": ${output.displayName}`;
    case 'installation_required':
      return `Install the app on development site "${output.siteId}": ${output.installUrl}`;
    case 'selected':
      return `Selected development site "${output.siteId}": ${output.source}`;
  }
}
